









import { Component, Vue, Prop } from 'vue-property-decorator'
import { VoteResult } from '@/class/game'
import { GamePlayerData } from '@/class/gamePlayer'
import { RoleId, GameState } from '@/enum'
import { GAME_STATE, MASTER_ROLE } from '@/class/const'
import Card from '@/components/Common/Card/Card.vue'
import VoteViewer from '../VoteViewer.vue'
import Message from './Message.vue'

@Component({
  components: {
    Card,
    VoteViewer,
    Message
  }
})
export default class VoteLog extends Vue {
  @Prop() playerOf!: {[id: string]: GamePlayerData};
  @Prop() state!: GameState;
  @Prop() voteResult!: VoteResult;
  @Prop() isFullclose!: boolean;
  logs: string[] = []
  openRoleIds: RoleId[] = []

  get header (): string {
    return `${GAME_STATE[this.state]}の結果`
  }

  get votedData () {
    return this.voteResult.votedData
  }

  created () {
    if (this.voteResult.punishedPlayerId) {
      const punishedPlayer = this.playerOf[this.voteResult.punishedPlayerId]

      if (punishedPlayer.roleId === RoleId.nobleman) {
        this.logs.push(`${punishedPlayer.name}さんがお金と権力の力で処刑を免れました`)
        this.openRoleIds.push(RoleId.nobleman)
      } else {
        if (this.isFullclose) {
          this.logs.push(`${punishedPlayer.name}さんが投票により処刑されました`)
        } else {
          if (punishedPlayer.roleId) {
            this.logs.push(`${punishedPlayer.name}(${MASTER_ROLE[punishedPlayer.roleId].name})さんが投票により処刑されました`)
            this.openRoleIds.push(punishedPlayer.roleId)
          }
        }

        if (punishedPlayer.roleId === RoleId.daughter) {
          this.voteResult.votedData.vote[punishedPlayer.id].forEach(playerId => {
            this.logs.push(`${this.playerOf[playerId].name}さんがゴッドファーザーにより殺害されました`)
          })
          this.openRoleIds.push(RoleId.daughter)
        }
      }
    } else if (this.voteResult.finalVotePlayerIds) {
      const playerNames = this.voteResult.finalVotePlayerIds.map(playerId => this.playerOf[playerId].name).join(' ')
      this.logs.push(`${playerNames}が同票だったため決選投票を行います`)
    } else {
      this.logs.push('今夜は処刑は行われませんでした')
    }
  }
}
